import React from 'react';
const ArrowRight = () => (
  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="33">
    <path d="M261.743306 947.106726 240.124939 921.16796 731.123626 512 240.124939 102.83204 261.743306 76.893274 783.874037 512Z" />
  </svg>
);
export default ArrowRight;
